<template>
  <div class="yxtbiz-rank-setter">
    <yxt-drawer
      size="640px"
      :visible.sync="openPage"
      destroy-on-close
      :before-close="handleClose"
    >
      <div slot="title">
        <span v-if="title && title.length" class="standard-size-12 text-59">
          <span
            v-for="(item, index) of title"
            :key="index"
            :class="{
              'text-8c hand': !index,
              'yxtf-weight-6': index === title.length - 1
            }"
            @click="onClickTitle(index)"
          >
            <span :class="{ 'hover-primary-6': !index }"> {{ item }}</span>
            <span v-if="index !== title.length - 1" class="ml4 mr4"
              ><i class="yxt-icon-arrow-right"></i
            ></span>
          </span>
        </span>
        <span v-else>{{ $t('pc_biz_rank_setter_title').d('添加榜单') }}</span>
      </div>
      <div v-loading="loading" class="yxtbiz-rank-setter_main ph8">
        <div class="yxtbiz-rank-setter_tab flex text-59 mb24">
          <div
            class="flex mr32 yxtbiz-rank-setter_tab_item"
            :class="{ 'yxtbiz-rank-setter_tab_active': tab === 'rule' }"
          >
            <div
              v-if="tab === 'rule'"
              class="yxtbiz-rank-setter_tab_num standard-size-12"
            >
              1
            </div>
            <div v-else class="yxtbiz-rank-setter_tab_check">
              <i class="yxt-icon-check"></i>
            </div>
            <div class="ml8">
              {{ $t('pc_biz_rank_rank_rule').d('排行规则') }}
            </div>
          </div>
          <div
            class="flex yxtbiz-rank-setter_tab_item"
            :class="{ 'yxtbiz-rank-setter_tab_active': tab === 'style' }"
          >
            <div
              v-if="!finishStyle || tab === 'style'"
              class="yxtbiz-rank-setter_tab_num text-8c standard-size-12"
            >
              2
            </div>
            <div v-else class="yxtbiz-rank-setter_tab_check">
              <i class="yxt-icon-check"></i>
            </div>
            <div class="ml8">
              {{ $t('pc_biz_rank_rank_style').d('排行样式') }}
            </div>
          </div>
        </div>
        <div>
          <rankRule
            v-show="tab === 'rule'"
            ref="rankRule"
            :title="title"
            :module="module"
            :functionCode="functionCode"
            :dataPermissionCode="dataPermissionCode"
            :enableGroupCorp="enableGroupCorp"
            @handleClose="handleClose"
          ></rankRule>
          <rankStyle
            v-show="tab === 'style'"
            ref="rankStyle"
            :dateList="dateList"
            :defaultDate="defaultDate"
            :contentList="contentList"
            :content="content"
          ></rankStyle>
        </div>
      </div>
      <div slot="footer">
        <yxt-button plain @click="handleClose">{{
          $t('pc_biz_common_cancel_mini')
        }}</yxt-button>
        <yxt-button v-if="tab === 'rule'" type="primary" @click="goNextStep">{{
          $t('pc_biz_rank_next_step').d('下一步')
        }}</yxt-button>
        <yxt-button v-else plain @click="goPrevStep">{{
          $t('pc_biz_rank_prev_step').d('上一步')
        }}</yxt-button>
        <yxt-button
          v-if="tab === 'style'"
          type="primary"
          @click="handleSure"
          :loading="submitLoading"
          >{{ $t('pc_biz_common_btn_sure') }}</yxt-button
        >
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
import rankRule from './rank-rule.vue';
import rankStyle from './rank-style.vue';
import { apiBaseUrl, miscApi } from 'yxt-biz-pc/packages/api';
import { nameList, simpleNameList } from './config';

export default {
  name: 'YxtbizRankSetter',
  components: {
    rankRule,
    rankStyle
  },
  props: {
    // 显示设置器
    openPage: {
      type: Boolean,
      default: false
    },
    // 榜单设置器ID（传值即为编辑）
    rankId: {
      type: String | Number,
      default: ''
    },
    // 导航的功能权限
    functionCode: {
      type: String,
      default: ''
    },
    // 数据权限code
    dataPermissionCode: {
      type: String,
      default: ''
    },
    // 是否是集团版
    enableGroupCorp: {
      type: Boolean,
      default: false
    },
    // 抽屉的标题 -- 默认 添加榜单
    title: {
      type: Array,
      default: () => []
    },
    // 编辑类型 -- 1:编辑 2：新增，会重新返回一个新的ID
    editType: {
      type: Number,
      default: 1
    },
    // 使用平台标识 -- op: 运营平台， xuanxing: 主站
    module: {
      type: String,
      default: 'xuanxing'
    }
  },
  data() {
    return {
      tab: 'rule', // 当前显示的tab -- rule 排行规则，style 排行样式
      dateList: [], // 选中的排行周期
      defaultDate: 1, // 默认排行周期
      contentList: [], // 展示内容
      content: '', // 默认选中的内容
      loading: false, // 加载中
      submitLoading: false, // 提交中
      finishStyle: false // 第二步已完成
    };
  },
  watch: {
    openPage(v) {
      v && this.init();
    }
  },
  methods: {
    // 初始化数据
    async init() {
      this.tab = 'rule';
      this.finishStyle = false;
      if (this.rankId) {
        try {
          this.loading = true;
          const data = await apiBaseUrl.get(`/rank/rankconfig/${this.rankId}`);
          this.formatData(data);
          this.loading = false;
        } catch (err) {
          err &&
            err.error &&
            err.error.message &&
            this.$message.error(err.error.message);
          this.loading = false;
        }
      }
    },
    // 编辑时，赋值
    formatData(data) {
      this.finishStyle = true;
      this.$refs.rankRule.init(data);
      this.$refs.rankStyle.init(data);
    },
    // 点击标题
    onClickTitle(index) {
      !index && this.handleClose();
    },
    // 关闭抽屉
    handleClose() {
      if (!this.rankId) {
        this.$emit('closePage');
        return;
      }
      this.$refs.rankRule.$refs.rankForm.getFormChangedStatus(isChanged => {
        if (isChanged) {
          this.confirmPop();
        } else {
          this.$refs.rankStyle.$refs.rankForm.getFormChangedStatus(
            isChanged => {
              if (isChanged) {
                this.confirmPop();
              } else {
                this.$emit('closePage');
              }
            }
          );
        }
      });
    },
    // 编辑时的取消确认框
    confirmPop() {
      this.$confirm(
        this.$t('pc_biz_rank_back_tip2').d('如需继续编辑请点击取消按钮'),
        this.$t('pc_biz_rank_back_tip1').d(
          '你有未保存的内容，确定放弃并返回吗？'
        ),
        {
          type: 'warning'
        }
      ).then(() => {
        this.$emit('closePage');
      });
    },
    // 下一步
    goNextStep() {
      if (this.loading) {
        return;
      }
      this.$refs.rankRule.$refs.rankForm.validate(async valid => {
        if (valid) {
          const data = this.$refs.rankRule.getStyleConfig();
          this.dateList = data.dateList;
          this.defaultDate = data.date;
          this.contentList.splice(
            0,
            this.contentList.length,
            ...data.contentList
          );
          const deptConfig = await miscApi.get('/security/dept/config');
          const { pathState } = deptConfig;
          if (pathState === 2) {
            this.contentList = this.contentList.filter(e => e.type !== 'deptName');
          }
          this.content = data.content;
          this.tab = 'style';
          this.finishStyle = true;
        }
      });
    },
    // 上一步
    goPrevStep() {
      this.tab = 'rule';
    },
    // 确定
    handleSure() {
      this.$refs.rankRule.$refs.rankForm.validate(valid => {
        if (!valid) {
          this.tab !== 'rule' && (this.tab = 'rule');
        } else {
          this.$refs.rankStyle.$refs.rankForm.validate(valid => {
            if (!valid) {
              this.tab !== 'style' && (this.tab = 'style');
            } else {
              const params = JSON.parse(
                JSON.stringify({
                  ...this.$refs.rankRule.rankForm,
                  ...this.$refs.rankStyle.rankForm
                })
              );
              if (params.excludeUser && params.excludeUser.length) {
                params.excludeUser =
                  params.objectCode === 'user'
                    ? params.excludeUser.map(e => ({
                      orgId: e.orgId,
                      userId: e.id
                    }))
                    : [];
              }
              if (params.deptScope && params.deptScope.length) {
                params.deptScope =
                  params.objectCode !== 'user'
                    ? params.deptScope.map(e => ({
                      id: e.id,
                      includeAll: 1
                    }))
                    : [];
              }
              this.submit(params);
            }
          });
        }
      });
    },
    // 保存
    async submit(params) {
      try {
        this.submitLoading = true;
        const index = this.$refs.rankRule.getIndex();
        // 没有编辑，每一次都会新增
        // 新增
        let { id } = await apiBaseUrl.post('/rank/rankconfig', params);
        // if (this.rankId && this.editType === 1) {
        //   await apiBaseUrl.put(`/rank/rankconfig/${this.rankId}`, params);
        // }
        this.$emit('closePage', {
          id,
          name: nameList[index[0]][index[1]].label,
          simpleName: simpleNameList[index[0]].label
        });
        this.submitLoading = false;
      } catch (err) {
        this.submitLoading = false;
        err &&
          err.error &&
          err.error.message &&
          this.$message.error(err.error.message);
      }
    }
  }
};
</script>
